import React, { useCallback, useEffect, useState } from "react";

import { Search as SearchIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import { SearchIconContainer, SearchInput } from "./styles";
import { SearchCompanyProps } from "Components/SideBar/types";

const SearchCompany = ({ onChangeInput, searchInputValue }: SearchCompanyProps) => {
  const { t: translate } = useTranslation();
  const [inputValue, setInputValue] = useState<string>("");
  const handleOnChangeInput = () => {
    onChangeInput(inputValue);
  };

  const debounce = useCallback(() => {
    if (!inputValue && !searchInputValue) return setTimeout(() => {});

    return setTimeout(() => {
      onChangeInput(inputValue);
    }, 500);
  }, [inputValue]);

  useEffect(() => {
    debounce();

    return () => clearTimeout(debounce());
  }, [debounce]);

  return (
    <SearchInput
      name="search-company-by-name"
      type="text"
      value={inputValue}
      onKeyDown={(event) => event.stopPropagation()}
      onChange={(event) => setInputValue(event.target.value)}
      placeholder={translate("search")}
      rightIcon={
        <SearchIconContainer onClick={handleOnChangeInput}>
          <SearchIcon />
        </SearchIconContainer>
      }
    />
  );
};

export default SearchCompany;
